import { render } from "./TalleresAnualPage.vue?vue&type=template&id=f7b50de8&scoped=true"
import script from "./TalleresAnualPage.vue?vue&type=script&lang=js"
export * from "./TalleresAnualPage.vue?vue&type=script&lang=js"

import "./TalleresAnualPage.vue?vue&type=style&index=0&id=f7b50de8&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f7b50de8"]])

export default __exports__